import React from "react"
// nodejs library that concatenates classes

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
import Intercom from "react-intercom"
import { ConsentGate, MetomicProvider } from "@metomic/react"

// core components
import Header from "components/Header/Header.jsx"
import Footer from "components/Footer/Footer.jsx"
import HeaderLinks from "components/Header/HeaderLinks.jsx"

import landingPageStyle from "assets/jss/material-kit-react/views/landingPage.jsx"

const path = require("path")

const dashboardRoutes = []

class Wrapper extends React.Component {
  render() {
    const { classes, componentToRender, ...rest } = this.props
    return (
      <MetomicProvider projectId="prj:accdd91c-3da6-4086-918b-7b744225d8fe">
        <>
          {/* <ConsentGate micropolicy="my-policy"></ConsentGate> */}
          <Intercom appID="fyagp7wv" />
          <Header
            color="transparent"
            routes={dashboardRoutes}
            brand="Privasee"
            rightLinks={<HeaderLinks />}
            fixed
            changeColorOnScroll={{
              height: 100,
              color: "white",
            }}
          />

          {this.props.children}
          <Footer />
        </>
      </MetomicProvider>
    )
  }
}

export default withStyles(landingPageStyle)(Wrapper)
